import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {GuardService} from '../guard/guard.service';
import {UserAclService} from '../../services/infrastructure/auth/acl/user-acl/user-acl.service';

export const answersGuard: CanActivateFn = () => {
  const guardService = inject(GuardService);
  const userAclService = inject(UserAclService);

  const hasPermissions = userAclService.isContentCreatorRole()
    || userAclService.isApplicationAdmin()
    || userAclService.isLibraryAdmin();
  if (hasPermissions) {
    return true;
  }
  return guardService.createRedirectUrlTree();
};
